import {AfterViewInit, Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {SwPush, SwUpdate} from '@angular/service-worker';
import {Subscription} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {NavigationItem} from '../../../models/navigationItem';
import {AnnouncementsService} from '../../../services/announcements.service';
import {CommonService} from '../../../services/common.service';
import {FileService} from '../../../services/file.service';
import {HeaderService} from '../../../services/header.service';
import {LocalStorageService} from '../../../services/local-storage.service';
import {NotificationService} from '../../../services/notification.service';
import {PushNotificationService} from '../../../services/push-notification.service';
import {ToastMessagesService} from '../../../services/toast-messages.service';
import {FeaturesSectionComponent} from '../../features-section/features-section.component';
// tslint:disable-next-line:import-spacing
import {
    NotificationsAnnouncementsDialogComponent
} from '../../home/notifications-announcements-dialog/notifications-announcements-dialog.component';
import {AnnouncementsDialogComponent} from '../announcements-dialog/announcements-dialog.component';
import {ConfirmDialogComponent} from '../confirm-dialog/confirm-dialog.component';
import {NavigationDialogComponent} from '../navigation-dialog/navigation-dialog.component';

@Component({
    selector: 'app-header-layout',
    templateUrl: './header-layout.component.html',
    styleUrls: ['./header-layout.component.scss']
})
export class HeaderLayoutComponent implements OnInit, AfterViewInit, OnDestroy {
    public user: any;
    public appVersion: any;
    public navigationItems: NavigationItem[] | any = [];
    public notificationNumber: number;
    public navigationPanelOpen: boolean;
    announcements: any;
    announcementsNumber: number;
    notifications: any;
    imageSource: any;
    spinnerColor: 'color: white';
    spinnerStroke: 1;
    loading: boolean;
    pageLoaded: boolean;
    greetingMessage: string;
    headerTitle: string;
    headerEventsSubscription: Subscription;
    prevIsMobileState: boolean;
    isMobile: boolean;
    logoSource: string;

    constructor(private localStorageService: LocalStorageService, private commonService: CommonService,
                private headerService: HeaderService,
                public router: Router, public dialog: MatDialog, public toastMessagesService: ToastMessagesService,
                private pushNotificationService: PushNotificationService, public fileService: FileService,
                private announcementsService: AnnouncementsService,
                private swPush: SwPush, private swUpdate: SwUpdate, private notificationService: NotificationService) {
        this.headerTitle = '';
        this.pageLoaded = false;
        this.navigationPanelOpen = false;
        this.notificationNumber = 0;
        this.announcementsNumber = 0;
        this.appVersion = environment.version;
        this.loading = true;
        this.user = JSON.parse(this.localStorageService.get('user'));
        const curHr = new Date().getHours();

        if (curHr < 12) {
            this.greetingMessage = 'Καλημέρα';
        } else {
            this.greetingMessage = 'Καλησπέρα';
        }
        this.isMobile = false;
        this.prevIsMobileState = false;
        // this.logoSource = environment.productSchoolId === 1 ? 'assets/images/haefLogo-1.png' : 'assets/images/protypa-custom-logo.png';
        this.logoSource = environment.productSchoolId === 1 ? 'assets/images/eapply-logo-1.png' : 'assets/images/protypa-custom-logo.png';
        // this.logoSource = environment.productSchoolId === 1 ? 'assets/images/haef-form-logo.png' : 'assets/images/protypa-custom-logo.png';

    }

    async ngOnInit() {
        this.checkForMobile();
        if(this.isMobile) {
            this.subscribeToHeaderEvents();
        }
        await this.checkExternalChildren();
        // await this.getLogo();


        this.notificationService.displayNotifications.subscribe(() => {
            this.initNotifications(false);
        });
        await this.pushNotificationService.pushSubscription(this.user.id);


        this.swPush.messages.subscribe(async (message) => {
            this.toastMessagesService.toastMessages(`Έχετε ειδοποιήσεις`);
            console.log('initializing notifications');
            await this.initNotifications(true);
            await this.initAnnouncements(true);
        });

        this.swPush.notificationClicks.subscribe(({action, notification}) => {
            window.open(notification.data.url);
        });
    }

    async ngAfterViewInit() {
        this.navigationItems = await this.userCanNavigateTo();
        // await this.initNotifications(false);
        // await this.initAnnouncements(false);
        this.pageLoaded = true;
    }

    ngOnDestroy() {
        if (this.headerEventsSubscription) {
            this.headerEventsSubscription.unsubscribe();
        }
    }

    // @HostListener('window:resize', ['$event'])
    // onResize(event) {
    //     this.checkForMobile();
    //     if(this.isMobile !== this.prevIsMobileState) {
    //
    //     }
    // }

    checkForMobile() {
        this.isMobile = window.matchMedia('(max-width: 960px)').matches;
    }

    subscribeToHeaderEvents() {
        this.headerEventsSubscription = this.headerService.observeHeaderTitle().subscribe(title => {
            if (title) {
                this.headerTitle = title;
            }
        });
    }

    async checkExternalChildren() {
        try {
            const checkChildrenRequest = await this.commonService.getList(`common/checkExternalChildren`);
            localStorage.setItem('externalClasses', checkChildrenRequest.object.toString());
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
            localStorage.removeItem('externalClasses');
        }
    }

    async initNotifications(force: boolean) {
        try {
            await this.notificationService.getAllNotifications(+this.user.id, force);
            this.notifications = this.notificationService.getInCompleteNotifications();
            this.notificationNumber = this.notifications.length;
        } catch (e) {
            console.log(e);
        }
    }

    async initAnnouncements(force: boolean) {
        try {
            await this.announcementsService.getAllAnnouncements(+this.user.id, force);
            this.announcements = this.announcementsService.announcements;
            this.announcementsNumber = this.announcements.length;
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        }
    }

    async userCanNavigateTo() {
        const menu = [];
        try {
            const items = await this.commonService.getList(`navigation?userId=${this.user.id}`);

            for (const item of items.object) {
                const index = menu.find(menuItem => menuItem.navigation_path_id === item.navigation_path_id);
                if (!index) {
                    menu.push(item);
                }
            }

            return menu;

        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
            console.log(e.message);
        } finally {
            this.loading = false;
        }
    }

    async logout() {
        this.localStorageService.clear('user');
        this.localStorageService.clear('token');
        await this.router.navigate(['login']);
    }

    showMenu() {
        if (!this.navigationPanelOpen) {
            this.navigationPanelOpen = true;
            const menuDialog = this.dialog.open(NavigationDialogComponent, {
                width: '250px',
                height: '100%',
                position: {
                    left: '0'
                },
                data: {
                    paths: this.navigationItems
                }
            });

            menuDialog.afterClosed().subscribe(async (path) => {
                this.navigationPanelOpen = false;
                if (path) {
                    await this.router.navigate([path]);
                }
            });
        } else {
            this.dialog.closeAll();
        }
    }

    isNotificationNumberVisible(): boolean {
        return this.notificationNumber === 0;
    }

    isAnnouncementsNumberVisible(): boolean {
        return this.announcementsNumber === 0;
    }

    async showForm(notification: any) {
        const inputConfig = {
            parentId: this.user.id,
            parentDisplayName: `${this.user.firstName} ${this.user.lastName}`,
            childId: notification.childId,
            childDisplayName: ``,
            childBirthday: ``,
            consentTypeId: notification.formId,
            mode: notification.mode
        };

        await this.router.navigate(['/home/consentForm'], {queryParams: inputConfig});
    }


    showBottomSheet() {
        this.headerService.setShowBottomSheet(true);
    }


    promptLogout() {
        const confirm = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: 'Έξοδος',
                message: 'Είστε σίγουροι οτι θέλετε να αποσυνδεθείτε?',
            }
        });

        confirm.afterClosed().subscribe(async (response) => {
            if (response) {
                await this.logout();
            }
        });
    }

    checkForUpdates() {
        if (this.swUpdate.isEnabled) {
            this.toastMessagesService.toastMessages(`Γίνεται έλεγχος για ενημερώσεις`);
            this.swUpdate.checkForUpdate().then(() => this.toastMessagesService.toastMessages('Γίνεται έλεγχος για ενημερώσεις'))
                .catch((reason) => this.toastMessagesService.toastErrorMessage(reason));
        } else {
            console.log('problem');
            this.toastMessagesService.toastErrorMessage(`Πρόβλημα με τον Service Worker`);
        }
    }

    async navigateToFeatures() {
        this.dialog.open(FeaturesSectionComponent, {});
        // await this.router.navigate(['home/features']);
    }

    async getLogo() {
        try {
            const res = await this.fileService.downloadFile(`college/logo`);
            const reader = new FileReader();
            reader.readAsDataURL(res);
            reader.onloadend = () => {
                this.imageSource = reader.result;
            };
        } catch (e) {
            // this.toastMessagesService.toastErrorMessage(e.message);
            this.imageSource = '';
        }
    }

    async navigateToUserSettings() {
        await this.router.navigate(['home/user-settings']);
    }

    showAnnouncementsDialog() {
        this.dialog.open(AnnouncementsDialogComponent, {
            width: '100%',
            height: '100%',
            panelClass: 'no-padding-dialog',
            data: {
                mode: 0,
                title: 'Ειδοποιήσεις',
                announcements: this.announcements
            }
        });
    }

    showNotificationsDialog() {
        this.dialog.open(AnnouncementsDialogComponent, {
            width: '100%',
            height: '100%',
            panelClass: 'no-padding-dialog',
            data: {
                mode: 1,
                user: this.user,
                title: 'Δηλωσεις',
                announcements: this.notifications
            }
        });
    }

    async navigateToHome() {
        await this.router.navigate(['home']);
    }

    async navigateToSearch() {
        await this.router.navigate(['home/search']);
    }

    async navigateToHistory() {
        await this.router.navigate(['home/mobile-history']);
    }

    showNotifications() {
        this.dialog.open(NotificationsAnnouncementsDialogComponent, {
            width: '85%',
            height: '60%',
            data: {
                currentUser: this.user,
                notifications: this.notifications
            }
        });
    }

    async navigateTo(route: string, drawer: any) {
        drawer.toggle();
        await this.router.navigate([`/home/${route}`]);
    }
}
